export default __webpack_public_path__ + "images/1aed48efae34b7805d8cdf9735d80d06.png";